import type { OverlayManifestData } from "./types";

// AUTO-BUILT for Yamunotri (697b96b8). Hindi strings sliced verbatim from word_timestamps_hindi.
export const yamunotriManifest: OverlayManifestData = {
  "production_id": "697b96b8-9788-492a-8410-150fe9ee717c",
  "temple": "Yamunotri",
  "temple_hindi": "यमुनोत्री",
  "total_duration_ms": 746875,
  "overlays": [
    {
      "type": "scripture_ref",
      "start_ms": 22000,
      "end_ms": 29500,
      "data": {
        "scripture": "Mahabharata",
        "section": "Van Parva · 82.89"
      }
    },
    {
      "type": "quote_card",
      "start_ms": 27500,
      "end_ms": 34000,
      "data": {
        "text": "यमुना उद्गम में स्नान का फल अश्वमेध यज्ञ के बराबर है",
        "source": "Mahabharata · Van Parva",
        "translation": "Bathing at Yamuna's source equals the merit of an Ashvamedha yajna"
      }
    },
    {
      "type": "location_tag",
      "start_ms": 73000,
      "end_ms": 78000,
      "data": {
        "name": "Yamunotri",
        "name_hindi": "यमुनोत्री",
        "detail": "First of the Char Dham"
      }
    },
    {
      "type": "stat_card",
      "start_ms": 76300,
      "end_ms": 81000,
      "data": {
        "headline": "ALTITUDE",
        "sub": "Yamunotri · the climb",
        "value_num": 3291,
        "suffix": " m"
      }
    },
    {
      "type": "location_tag",
      "start_ms": 80000,
      "end_ms": 85000,
      "data": {
        "name": "Janki Chatti",
        "name_hindi": "जनकीचट्टी",
        "detail": "Road ends · 6 km on foot"
      }
    },
    {
      "type": "person_tag",
      "start_ms": 93400,
      "end_ms": 99000,
      "data": {
        "name": "Atkinson",
        "role": "Himalayan Gazetteer",
        "name_hindi": "एटकिन्सन"
      }
    },
    {
      "type": "year_stamp",
      "start_ms": 95000,
      "end_ms": 101000,
      "data": {
        "display": "उन्नीसवीं सदी",
        "display_latin": "19th C.",
        "context": "Atkinson's Himalayan Gazetteer"
      }
    },
    {
      "type": "person_tag",
      "start_ms": 131000,
      "end_ms": 137000,
      "data": {
        "name": "Yamuna",
        "role": "Daughter of Surya · Sister of Yama",
        "name_hindi": "यमुना"
      }
    },
    {
      "type": "person_tag",
      "start_ms": 131300,
      "end_ms": 136500,
      "data": {
        "name": "Surya",
        "role": "The Sun · Yamuna's father",
        "name_hindi": "सूर्य"
      }
    },
    {
      "type": "person_tag",
      "start_ms": 133600,
      "end_ms": 138600,
      "data": {
        "name": "Yama",
        "role": "God of Death · Yamuna's brother",
        "name_hindi": "यम"
      }
    },
    {
      "type": "info_box",
      "start_ms": 152500,
      "end_ms": 163000,
      "data": {
        "label": "RAKSHA BANDHAN",
        "text": "Yama blessed any who bathe at the Yamuna remembering the sibling bond — the vow that lives on as Raksha Bandhan."
      }
    },
    {
      "type": "location_tag",
      "start_ms": 171000,
      "end_ms": 176000,
      "data": {
        "name": "Surya Kund",
        "name_hindi": "सूर्य कुंड",
        "detail": "The boiling spring"
      }
    },
    {
      "type": "stat_card",
      "start_ms": 178300,
      "end_ms": 181900,
      "data": {
        "headline": "WINTER TEMPERATURE",
        "sub": "Drops this low up here",
        "value_str": "−20",
        "suffix": " °C"
      }
    },
    {
      "type": "stat_card",
      "start_ms": 182600,
      "end_ms": 186800,
      "data": {
        "headline": "SURYA KUND",
        "sub": "The water boils",
        "value_num": 89,
        "suffix": " °C"
      }
    },
    {
      "type": "person_tag",
      "start_ms": 185900,
      "end_ms": 191000,
      "data": {
        "name": "Kumar & Sharma",
        "role": "Heliyon · 2020",
        "name_hindi": "कुमार और शर्मा"
      }
    },
    {
      "type": "stat_card",
      "start_ms": 191600,
      "end_ms": 196400,
      "data": {
        "headline": "AVG TEMPERATURE",
        "sub": "Kumar & Sharma · Heliyon 2020",
        "value_num": 87.8,
        "suffix": " °C",
        "decimals": 1
      }
    },
    {
      "type": "stat_card",
      "start_ms": 215400,
      "end_ms": 219000,
      "data": {
        "headline": "DRAUPADI KUND",
        "sub": "",
        "value_num": 67,
        "suffix": " °C"
      }
    },
    {
      "type": "stat_card",
      "start_ms": 219200,
      "end_ms": 223800,
      "data": {
        "headline": "YAMUNOTRI TAPT KUND",
        "sub": "Where pilgrims bathe",
        "value_str": "46–48",
        "suffix": " °C"
      }
    },
    {
      "type": "info_box",
      "start_ms": 226500,
      "end_ms": 237000,
      "data": {
        "label": "THERMOTOLERANT LIFE",
        "text": "Microbes survive near 100°C in the boiling kund — where almost nothing should live."
      }
    },
    {
      "type": "like_subscribe",
      "start_ms": 238500,
      "end_ms": 248000,
      "data": {
        "variant": "ls_03",
        "placement_index": 1,
        "moment_context": "After the boiling-water + microbial life reveal"
      }
    },
    {
      "type": "info_box",
      "start_ms": 257000,
      "end_ms": 270000,
      "data": {
        "label": "FAULT ZONE",
        "text": "Yamunotri sits on a geological fault — the Indian plate sliding under the Eurasian. It fuels the hot springs, and the landslides."
      }
    },
    {
      "type": "stat_card",
      "start_ms": 280700,
      "end_ms": 286000,
      "data": {
        "headline": "VEHICLE CAPACITY",
        "sub": "Yamunotri route · Uttarkashi DDMA 2026",
        "value_num": 1560
      }
    },
    {
      "type": "person_tag",
      "start_ms": 332800,
      "end_ms": 338000,
      "data": {
        "name": "P.N. Chopra",
        "role": "UP District Gazetteer · Uttarkashi",
        "name_hindi": "पी एन चोपड़ा"
      }
    },
    {
      "type": "year_stamp",
      "start_ms": 337000,
      "end_ms": 343000,
      "data": {
        "display": "उन्नीस सौ उन्यासी",
        "display_latin": "1979",
        "context": "Chopra's Uttarkashi Gazetteer"
      }
    },
    {
      "type": "person_tag",
      "start_ms": 340600,
      "end_ms": 346000,
      "data": {
        "name": "Maharani Baijabai Shinde",
        "role": "Gwalior · built the first temple",
        "name_hindi": "महारानी बैजाबाई शिंदे"
      }
    },
    {
      "type": "person_tag",
      "start_ms": 346300,
      "end_ms": 351500,
      "data": {
        "name": "Maharaja Pratap Shah",
        "role": "Tehri Garhwal · rebuilt it",
        "name_hindi": "महाराजा प्रताप शाह"
      }
    },
    {
      "type": "person_tag",
      "start_ms": 354600,
      "end_ms": 360000,
      "data": {
        "name": "Maharani Gularia",
        "role": "Jaipur · built the present temple",
        "name_hindi": "महारानी गुलारिया"
      }
    },
    {
      "type": "info_box",
      "start_ms": 362600,
      "end_ms": 372000,
      "data": {
        "label": "ONE TEMPLE · THREE QUEENS",
        "text": "Gwalior, Tehri, Jaipur — three queens rebuilt it across centuries, and unnamed masons restored it after every winter."
      }
    },
    {
      "type": "location_tag",
      "start_ms": 387600,
      "end_ms": 393500,
      "data": {
        "name": "Champasar Glacier",
        "name_hindi": "चम्पासर हिमनद",
        "detail": "Yamuna's true source · 1 km above the temple"
      }
    },
    {
      "type": "location_tag",
      "start_ms": 390000,
      "end_ms": 395500,
      "data": {
        "name": "Bandarpunch",
        "name_hindi": "बंदरपुंछ चोटी",
        "detail": "Peak above the glacier source"
      }
    },
    {
      "type": "location_tag",
      "start_ms": 425000,
      "end_ms": 431000,
      "data": {
        "name": "Kharsali",
        "name_hindi": "खारसाली",
        "detail": "Winter seat of the goddess"
      }
    },
    {
      "type": "info_box",
      "start_ms": 434000,
      "end_ms": 444000,
      "data": {
        "label": "KHARSALI · KHUSHI MATH",
        "text": "For six winter months the idol resides in Kharsali's old Shani temple — the village's ancient name is Khushi Math."
      }
    },
    {
      "type": "info_box",
      "start_ms": 446000,
      "end_ms": 455500,
      "data": {
        "label": "AKSHAYA TRITIYA",
        "text": "On Akshaya Tritiya the idol returns by doli and the temple reopens — it dies each winter, revives each spring."
      }
    },
    {
      "type": "stat_card",
      "start_ms": 471700,
      "end_ms": 477000,
      "data": {
        "headline": "ZERO-PILGRIM DAYS",
        "sub": "Yamunotri · 2025 (Down To Earth)",
        "value_num": 23
      }
    },
    {
      "type": "stat_card",
      "start_ms": 483700,
      "end_ms": 489000,
      "data": {
        "headline": "ZERO-PILGRIM DAYS",
        "sub": "Char Dham + Hemkund · Yamunotri: 30",
        "value_num": 55
      }
    },
    {
      "type": "stat_card",
      "start_ms": 503000,
      "end_ms": 506700,
      "data": {
        "headline": "PILGRIMS · 210 DAYS",
        "sub": "Char Dham circuit · SDC Foundation 2026",
        "value_num": 5100000
      }
    },
    {
      "type": "stat_card",
      "start_ms": 507000,
      "end_ms": 512000,
      "data": {
        "headline": "ARRIVED IN FIRST 60 DAYS",
        "sub": "of the season's pilgrims",
        "value_num": 72,
        "suffix": " %"
      }
    },
    {
      "type": "stat_card",
      "start_ms": 530600,
      "end_ms": 535500,
      "data": {
        "headline": "PILGRIMS · 1975",
        "sub": "Springer 2023",
        "value_num": 30000
      }
    },
    {
      "type": "stat_card",
      "start_ms": 543400,
      "end_ms": 549000,
      "data": {
        "headline": "PILGRIMS · 2010",
        "sub": "10× growth in 35 years",
        "value_num": 288000
      }
    },
    {
      "type": "stat_card",
      "start_ms": 550700,
      "end_ms": 554400,
      "data": {
        "headline": "PILGRIMS · 2011",
        "sub": "Uttarkashi DDMA",
        "value_num": 467502
      }
    },
    {
      "type": "stat_card",
      "start_ms": 561400,
      "end_ms": 567000,
      "data": {
        "headline": "PILGRIMS · 2020",
        "sub": "A pandemic shut it all",
        "value_num": 7850
      }
    },
    {
      "type": "like_subscribe",
      "start_ms": 575500,
      "end_ms": 585000,
      "data": {
        "variant": "ls_07",
        "placement_index": 2,
        "moment_context": "After the pandemic-collapse pilgrim number"
      }
    },
    {
      "type": "stat_card",
      "start_ms": 591000,
      "end_ms": 595500,
      "data": {
        "headline": "PILGRIMS · 2023",
        "sub": "",
        "value_num": 735245
      }
    },
    {
      "type": "stat_card",
      "start_ms": 600400,
      "end_ms": 604800,
      "data": {
        "headline": "PILGRIMS · 2024",
        "sub": "Highest ever",
        "value_num": 714755
      }
    },
    {
      "type": "stat_card",
      "start_ms": 607200,
      "end_ms": 612500,
      "data": {
        "headline": "PILGRIMS · 2025",
        "sub": "A slight dip",
        "value_num": 644637
      }
    },
    {
      "type": "person_tag",
      "start_ms": 622300,
      "end_ms": 628000,
      "data": {
        "name": "Apollo, Andrachuk & Wengel",
        "role": "Springer Publication · 2023"
      }
    },
    {
      "type": "stat_card",
      "start_ms": 631700,
      "end_ms": 635900,
      "data": {
        "headline": "TOURISM EMPLOYMENT",
        "sub": "Apollo et al. · Springer 2023",
        "value_num": 14.9,
        "prefix": "+",
        "suffix": " %",
        "decimals": 1
      }
    },
    {
      "type": "stat_card",
      "start_ms": 636400,
      "end_ms": 641500,
      "data": {
        "headline": "FARM EMPLOYMENT",
        "sub": "The trade-off",
        "value_num": 22.8,
        "prefix": "−",
        "suffix": " %",
        "decimals": 1
      }
    }
  ]
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
